module.exports = __webpack_public_path__ + "img/study.a75f8d5d.jpg";